/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import Actions from "../../fluid/Actions/ActionFactory";

import logo from '../../assets/sainapse_logo2.png'

import {
  Grid,
  Typography,
  Button,
  Divider,
  Chip,
  IconButton,
  Tooltip,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Paper
} from "@material-ui/core";
// const About = () => {
//   //about screen is not yet implemented.
//   return <></>;
// };

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc014e",
    },
  },
});


class About extends Component {
  state = {
    about: {},
    version: "",
    copyright: "",
    terms_and_conditions: "",
    loading_about : false
  }

  componentWillMount = () => {
    this.getAboutSainapse();
  }

  getAboutSainapse = () => {
    this.setState({...this.state, loading_about : true}, () => {
      Actions("http_request", {
        url: "/sainapse/about",
        method: "get",
        data: {},
      }).then((res) => {
        console.log("About Result: ", res.data.result);
        this.setState({ 
          about:  res.data.result,
          loading_about : false
        })
        // this.setState({...this.state, about : about, loading_about : false})
      });
    })
  }



  renderMeta = () => {
    let meta_values = this.state.about.meta
    let keys = Object.keys(meta_values)

    let meta_data = keys.map(key => meta_values[key])
    meta_data = meta_data.sort((a,b) => a.order - b.order)

    return (
      <Paper style = {{width : '100%', display : 'flex', flexDirection : 'column', alignItems : 'center', padding : '20px'}}>
          <img style = {{width : '200px', marginBottom : '20px'}} src = {logo} alt = ""/>
          <div style = {{display : 'flex', flexDirection : 'column'}}>
            {
              meta_data.map(meta => {
                if (meta.value !== null) {
                  return (
                    <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                      <Typography style = {{flexGrow : 1, marginRight : '10px'}} variant = 'body2'>{meta.label + " : "}</Typography>
                      <Typography align = 'right' variant = 'subtitle2'>{"  " + meta.value}</Typography>
                    </div>
                  )
                } else {
                  return null
                }
              })
            }
          </div>
        </Paper>
    )
  }

  renderSections = () => {
    let sections = this.state.about.sections
    let render_sections = sections.map(section => {
      return (
        <div>
          <Typography variant = {section.heading.format}>{section.heading.value}</Typography>
          <Typography variant = "body2" dangerouslySetInnerHTML = {{__html: section.body}}></Typography>
          <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>  
        </div>
      )
    })

    return (
      <Paper style = {{width : '100%', padding : '20px', marginTop : '20px'}}>
        {render_sections}
      </Paper> 
    )
  }

  render(){
    return (
      <div style = {{width : '100vw', height : '100%', display : 'flex', flexDirection : 'column', padding : '20px'}}>
        {!this.state.loading_about && this.renderMeta()}
        {!this.state.loading_about && this.renderSections()}
        {/* <Paper style = {{width : '60%', display : 'flex', flexDirection : 'column', alignItems : 'center', padding : '20px'}}>
          <img style = {{width : '200px'}} src = {logo} alt = ""/>
          <Typography style = {{marginTop : '30px'}} align = 'center' variant = 'body2'>“SAINAPSE” and “BAYESTREE” are both federally registered trademarks with the United States Patent and Trademark Office.</Typography>
          <Typography style = {{marginTop : '20px'}} variant = 'body2'>Sainapse incorporates “patent pending” technology.</Typography>
          <Typography style = {{marginTop : '20px'}} variant = 'body2'>Copyright Bayestree Intelligence Private Limited 2021. All rights reserved.</Typography>
        </Paper> */}
      </div>
    )
  }
}

export default About;
